import { absolutePath } from "./absolutePath";

export const mediaTranscodings = {
  create: () => absolutePath("media_transcodings"),
};
